import React, { useEffect, useState } from "react";
import { getAllGeneralLedger } from "../../api/endpoints/search";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { Modal, message, Select } from "antd";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { LuView } from "react-icons/lu";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import OpeningSideBar from "../openingSideBar/openingSIdeBar";
import Example from "./calling.js";
import {
  getLatestItemCode,
  createItem,
  getAllItemForUpdate,
  updateSingleItem,
  deleteSingleItem,
} from "../../api/endpoints/item";
const { Option } = Select;

const Item = () => {
  const [itemsQueue, setItemsQueue] = useState([]);
  const { user, access_token } = useSelector(authSelector);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [type, setType] = useState("ADD");
  const [state, setState] = useState({
    id: "",
    ledgerCodes: [],
    glCode: "",
    glDescription: "",
    items: [],
    itemCode: "",
    itemName: "",
    purchaseRate: "",
    saleRate: "",
    creditSaleRate: "",
    reOrder: "",
    shortName: "",
    printOrder: "",
    packQuantity: "",
    depriciation: "",
    gst: "",
    GL: "",
    closed: "",
    categoryItem: "",
  });

  const clearState = () => {
    setState({
      id: "",
      ledgerCodes: state.ledgerCodes,
      items: state.items,
      glCode: "",
      glDescription: "",
      itemCode: "",
      itemName: "",
      purchaseRate: "",
      saleRate: "",
      creditSaleRate: "",
      reOrder: "",
      shortName: "",
      printOrder: "",
      packQuantity: "",
      depriciation: "",
      gst: "",
      GL: "",
      closed: "",
      categoryItem: "",
    });
    setItemsQueue([]);
  };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const addTank = async () => {
    const _itemCode = await getLatestItemCode(access_token);
    setType("SAVE");
    setFieldsShow(true);
    setState({
      ...state,
      itemCode: _itemCode.data,
      closed: 0,
      GL: 1,
    });
  };
  //   console.log(state.generalLedgerCode.length,"leng")
  const saveTank = async (e) => {
    if (
      !state.categoryItem ||
      !state.itemName ||
      !state.glCode ||
      !state.glDescription ||
      !state.creditSaleRate ||
      !state.purchaseRate ||
      !state.saleRate ||
      !state.shortName ||
      !state.GL ||
      !state.packQuantity
    ) {
      return message.error(
        `Please type ${
          !state.glCode
            ? "General Ledger Code"
            : !state.glDescription
            ? "Gl Description"
            : !state.categoryItem
            ? "Category Item"
            : !state.itemName
            ? "Item Name"
            : !state.purchaseRate
            ? "Purchase Rate"
            : !state.saleRate
            ? "Sale Rate"
            : !state.creditSaleRate
            ? "Credit Sale Rate"
            : !state.shortName
            ? "Short Name"
            : !state.GL
            ? "Rate Gain/Loss"
            : !state.packQuantity
            ? "Pack Quantity"
            : ""
        }`
      );
    }

    const payload = {
      itemCode: Number(state.itemCode),
      itemName: state.itemName,
      purchaseRate: Number(state.purchaseRate),
      saleRate: Number(state.saleRate),
      creditSaleRate: Number(state.creditSaleRate),
      reOrder: Number(state.reOrder),
      shortName: state.shortName,
      printOrder: Number(state.printOrder),
      packQuantity: Number(state.packQuantity),
      categoryItem: Number(state.categoryItem),
      GL: Number(state.GL),
      closed: Number(state.closed),
      generalLedgerCode: Number(state.glCode),
      grpId: Number(user.grpId),
      siteId: Number(user.siteId),
      companyCode: Number(user.companyCode),
    };

    console.log(payload, "payload");

    const results = await createItem(payload, access_token);
    if (results.success) {
      message.success(results.message || "Successfully entered!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const editTank = async () => {
    setType("EDIT");
    setFieldsShow(true);
  };

  const saveEditTank = async (e) => {
    if (type === "EDIT") {
      if (
        !state.categoryItem ||
        !state.itemName ||
        !state.glCode ||
        !state.glDescription ||
        !state.creditSaleRate ||
        !state.purchaseRate ||
        !state.saleRate ||
        !state.shortName ||
        !state.GL ||
        !state.packQuantity
        // ||
        // !state.closed
      ) {
        return message.error(
          `Please type ${
            !state.glCode
              ? "General Ledger Code"
              : !state.glDescription
              ? "Gl Description"
              : !state.categoryItem
              ? "Category Item"
              : !state.itemName
              ? "Item Name"
              : !state.purchaseRate
              ? "Purchase Rate"
              : !state.saleRate
              ? "Sale Rate"
              : !state.creditSaleRate
              ? "Credit Sale Rate"
              : !state.shortName
              ? "Short Name"
              : !state.GL
              ? "Rate Gain/Loss"
              : !state.packQuantity
              ? "Pack Quantity"
              : // : !state.closed
                // ? "closed"
                ""
          }`
        );
      }
      const data = {
        id: state.id,
        itemCode: Number(state.itemCode),
        itemName: state.itemName,
        purchaseRate: Number(state.purchaseRate),
        saleRate: Number(state.saleRate),
        creditSaleRate: Number(state.creditSaleRate),
        reOrder: Number(state.reOrder),
        shortName: state.shortName,
        printOrder: Number(state.printOrder),
        packQuantity: Number(state.packQuantity),
        categoryItem: Number(state.categoryItem),
        GL: Number(state.GL),
        closed: Number(state.closed),
        generalLedgerCode: Number(state.glCode),
      };
      console.log(data, "edite data");
      const results = await updateSingleItem(data, access_token);
      if (results.success) {
        message.success(results.message || "Successfully Updated!");
        clearState();
        setFieldsShow(false);
        setType("ADD");
      } else {
        message.error(results.message);
      }
    } else {
      if (!state.itemCode) return message.error("Please Select Item");
      modal.confirm({
        title: `Confirm`,
        content: "Are you sure you want to delete this Item?",
        okText: "Delete",
        cancelText: "Cancel",
        onOk: confirmDeleteNozel,
      });
    }
  };
  const confirmDeleteNozel = async () => {
    const data = {
      itemCode: state.itemCode,
    };
    const results = await deleteSingleItem(data, access_token);
    if (results.success) {
      message.success(results.message || "Deleted Successfully!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const [modal, contextHolder] = Modal.useModal();
  const deleteNozel = async () => {
    setType("DELETE");
    setFieldsShow(true);
  };
  const confirmDelete = () => {
    modal.confirm({
      title: `Confirm`,
      content: "You want to delete Item?",
      okText: "Yes",
      cancelText: "Cancel",
      onOk: deleteNozel,
    });
  };

  const clearStates = () => {
    clearState();
    setFieldsShow(false);
    setType("ADD");
  };

  const getAllData = async () => {
    const _items = await getAllItemForUpdate(access_token);
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    setState({
      ...state,
      items: _items,
      ledgerCodes: _ledgerCodes,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editHandler = async (e) => {
    console.log("click");
    const results = await getAllItemForUpdate(access_token);

    const payload = results.reduce((acc, curr) => {
      return [
        ...acc,
        {
          itemCode: curr.itemCode,
          itemName: curr.itemName,
          saleRate: curr.saleRate,
        },
      ];
    }, []);

    setItemsQueue(payload);
  };

  console.log(state, "state");
  return (
    <>
      {itemsQueue.length > 0 ? (
        <>
          <div style={{ backgroundColor: "" }}>
            {itemsQueue.length > 0 && <Example item={itemsQueue} />}
          </div>
          <div className="pb-3 flex justify-center">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
              onClick={clearState}
            >
              Exit
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="flex bg-black main">
            <OpeningSideBar />
            <div className="h-full  flex flex-col content-center  w-full">
              <div className="flex justify-center">
                <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
                  <div className="bg-blue-500 headingBox flex justify-center">
                    <h1 className="text-white">Add Item</h1>
                    {contextHolder}
                  </div>
                  <div className="p-2 flex justify-center">
                    {fieldsShow && (
                      <div className="w-70">
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              Item Code:
                            </label>
                            {type === "EDIT" || type === "DELETE" ? (
                              <>
                                <Select
                                  className="bg-black text-slate-400 inpTxt  h-8 w-full"
                                  showSearch
                                  placeholder=""
                                  optionFilterProp="children"
                                  value={state.itemCode || ""}
                                  onChange={(e) => {
                                    const _accountInfo = state.items.find(
                                      (el) => el.itemCode === e
                                    );
                                    console.log("e", _accountInfo);

                                    setState({
                                      ...state,
                                      itemCode: e,
                                      id: _accountInfo.id,
                                      itemName: _accountInfo.itemName,
                                      glCode: _accountInfo.generalLedgerCode,
                                      glDescription:
                                        _accountInfo.chartOfAccount.description,
                                      purchaseRate: _accountInfo.purchaseRate,
                                      saleRate: _accountInfo.saleRate,
                                      creditSaleRate:
                                        _accountInfo.creditSaleRate,
                                      reOrder: _accountInfo.reOrder,
                                      shortName: _accountInfo.shortName,
                                      printOrder: _accountInfo.printOrder,
                                      packQuantity: _accountInfo.packQuantity,
                                      categoryItem: _accountInfo.categoryItem,
                                      GL: _accountInfo.GL,
                                      closed: _accountInfo.closed,
                                    });
                                  }}
                                >
                                  {state.items.map((el) => (
                                    // console.log(el, "el")
                                    <Option value={el.itemCode}>
                                      {`${el.itemCode} - ${el.itemName}`}
                                    </Option>
                                  ))}
                                </Select>
                              </>
                            ) : (
                              <input
                                readOnly
                                type="number"
                                name="partyId"
                                value={state.itemCode}
                                className="bg-black text-slate-400 pl-2  inpTxt h-8 w-full"
                              />
                            )}
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Item Name :
                            </label>
                            <input
                              type="text"
                              name="itemName"
                              value={state.itemName}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                            />
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              Purchase Rate :
                            </label>
                            <input
                              type="number"
                              name="purchaseRate"
                              value={state.purchaseRate}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full"
                            />
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Sale Rate :
                            </label>
                            <input
                              type="number"
                              name="saleRate"
                              value={state.saleRate}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                            />
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              Credit Sale Rate :
                            </label>
                            <input
                              type="number"
                              name="creditSaleRate"
                              value={state.creditSaleRate}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full"
                            />
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Category :
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt ml-3  h-9 w-full"
                              placeholder="Category"
                              optionFilterProp="children"
                              value={
                                state.categoryItem === ""
                                  ? "Fuel"
                                  : state.categoryItem
                              }
                              onChange={(value) =>
                                onChangeText({
                                  target: { name: "categoryItem", value },
                                })
                              }
                            >
                              <Option value={1} name="categoryItem">
                                Fuel
                              </Option>
                              <Option value={2} name="categoryItem">
                                Stock Item
                              </Option>
                              <Option value={3} name="categoryItem">
                                Non Stock Item
                              </Option>
                              <Option value={4} name="categoryItem">
                                Assets
                              </Option>
                              <Option value={5} name="categoryItem">
                                Office / Consumable
                              </Option>
                            </Select>
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white " htmlFor="fname">
                              Re Order :
                            </label>
                            <input
                              type="number"
                              name="reOrder"
                              value={state.reOrder}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full "
                            />
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Short Name :
                            </label>
                            <input
                              type="text"
                              name="shortName"
                              value={state.shortName}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                            />
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white " htmlFor="fname">
                              Print Order :
                            </label>
                            <input
                              type="number"
                              name="printOrder"
                              value={state.printOrder}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full "
                            />
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Pack Quantity :
                            </label>
                            <input
                              type="number"
                              name="packQuantity"
                              value={state.packQuantity}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                            />
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              GL Description :
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt  h-9 w-full"
                              placeholder="GL Description"
                              optionFilterProp="children"
                              value={state.glDescription || "GL Description "}
                              onChange={(e) => {
                                const lCode = state.ledgerCodes.find(
                                  (el) => el.generalLedgerCode === e
                                );
                                setState({
                                  ...state,
                                  glCode: e,
                                  glDescription: lCode.description,
                                });
                              }}
                            >
                              {state.ledgerCodes.map((el) => (
                                <Option value={el.generalLedgerCode}>
                                  {el.description}
                                </Option>
                              ))}
                            </Select>
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              GL Code :
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt  h-9 w-full ml-3"
                              placeholder="Credit GL Code"
                              optionFilterProp="children"
                              value={state.glCode || "Credit GL Code"}
                              onChange={(e) => {
                                const lCode = state.ledgerCodes.find(
                                  (el) => el.generalLedgerCode === e
                                );
                                setState({
                                  ...state,
                                  glCode: e,
                                  glDescription: lCode.description,
                                });
                              }}
                            >
                              {state.ledgerCodes.map((el) => (
                                <Option value={el.generalLedgerCode}>
                                  {el.generalLedgerCode}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              Rate Gain/ Loss:
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt  h-9 w-full"
                              placeholder=""
                              optionFilterProp="children"
                              value={state.GL === "" ? "Yes" : state.GL}
                              onChange={(value) =>
                                onChangeText({ target: { name: "GL", value } })
                              }
                            >
                              <Option value={0} name="GL">
                                No
                              </Option>
                              <Option value={1} name="GL">
                                Yes
                              </Option>
                            </Select>
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Closed:
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt ml-3 h-9 w-full"
                              placeholder="No"
                              optionFilterProp="children"
                              value={state.closed === "" ? "No" : state.closed}
                              onChange={(value) =>
                                onChangeText({
                                  target: { name: "closed", value },
                                })
                              }
                            >
                              <Option value={0} name="closed">
                                No
                              </Option>
                              <Option value={1} name="closed">
                                Yes
                              </Option>
                            </Select>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div class="flex justify-center pb-3">
                    {type === "ADD" && (
                      <button
                        onClick={addTank}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                      >
                        <AiFillFileAdd className="mr-2 mt-1" />

                        <span>Add</span>
                      </button>
                    )}

                    {type === "SAVE" && (
                      <button
                        onClick={saveTank}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                      >
                        <AiFillSave className="mt-1 mr-2 " />
                        <span>Save</span>
                      </button>
                    )}
                    {type === "ADD" && (
                      <button
                        onClick={editHandler}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white ml-2 mt-3 py-1 px-4 rounded"
                      >
                        <LuView className="mt-1 mr-2 " />
                        <span>View</span>
                      </button>
                    )}
                    {type === "ADD" && (
                      <button
                        onClick={editTank}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        <AiFillEdit className="mr-2 mt-1" />

                        <span>Edit</span>
                      </button>
                    )}

                    {(type === "EDIT" || type === "DELETE") && (
                      <button
                        onClick={saveEditTank}
                        className="bg-blue-500 hover:bg-blue-700 text-white ml-2 mt-3 py-1 px-4 rounded"
                      >
                        DONE
                      </button>
                    )}
                    {type === "ADD" && (
                      <button
                        onClick={confirmDelete}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        <AiFillDelete className="mr-2 mt-1" />

                        <span>Delete</span>
                      </button>
                    )}
                    {type !== "ADD" && (
                      <button
                        onClick={clearStates}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        <BiExit className="mr-2 mt-1" />
                        <span>Exit</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Item;
